const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the content feedback component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Feedback} Feedback the resource defined to manage Feedback
 */
app.directive('contentFeedback', ['Application', 'Authorization', 'Feedback', function (Application, Authorization, Feedback) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        contentType: '=',
        contentId: '='
      },
      template: require('../../templates/directives/content-feedback.html'),
      controller: ['$scope', function ($scope) {
        var self = this;
        self.getError = Application.notifications.getError;
        self.getSuccess = Application.notifications.getSuccess;
        var currentUser = Authorization.getAuthToken().user;
        self.show = false;

        var parseFeedback = function(items) {
          var found = false;
          angular.forEach(items, function(feedback) {
            if (!feedback.user) return;
            if (feedback.user.toString() === currentUser._id.toString()) {
              found = true;
            }
          });
          if (!found) {
            self.show = true;
          }
        };

        self.submitFeedback = function(assertion) {
          self.loading = true;
          Feedback.create({}, {
            user: currentUser._id,
            assertion: assertion,
            contentType: self.contentType,
            contentId: self.contentId
          }, function (data) {
            self.loading = false;
            self.show = false;
            Application.notifications.setSuccess('Thank you for your feedback!');
          }, function (error) {
            self.loading = false;
            console.log('Error occured creating feedback ', error);
            Application.notifications.setError('Unable to create feedback.');
          });
        };

        self.initialize = function () {
          self.contentType = $scope.contentType;
          self.contentId = $scope.contentId;
          var options = {};
          options[self.contentType] = self.contentId;
          options.fields = 'user,assertion'
          Feedback.find(options, function (data) {
            parseFeedback(data);
          }, function (error) {
            console.log('Error occured getting feedback ', error);
            Application.notifications.setError('Unable to get feedback.');
          });
        };
        self.initialize();
      }],
      controllerAs: 'feedback'
    };
  }]);
